// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__312FP","col":"styles_col__PfcW_"};